const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPei(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.908 770.382c-6.194 8.022 21.428 29.442 41.676 35.891 6.543 2.44 26.83-18.714 18.905-23.557-21.791-11.286-56.179-18.285-60.581-12.334",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.154 -561.002)scale(.93642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.104 774.191C42.135 868.077 49.447 858.111 6.43 915.86c-6.935 17.584 15.869 32.7 27.034 25.98 15.451-10.347 32.9-22.278 43.788-35.681 19.77-24.336 110.55-91.983 171.956-110.953 12.367-3.82 23.894-3.271 35.181-5.71 8.484-2.412-.039-15.02-4.698-19.791-15.705-16.55-43.366-26.34-52.425-19.817-3.975 1.966 1.93 29.481-2.892 32.065C177.776 804.76 91.39 863.627 52.126 893.77c-1.47.685 1.343-5.302 2.312-7.244 8.626-17.269 18.011-65.73 22.725-115.039.446-11.08-8.412-7.225-10.059 2.704",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(5.154 -561.002)scale(.93642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.097 711.598c-10.019-1.064-15.49 8.808-14.343 18.463.974 8.187 1.252 18.673 9.833 27.56 5.646 6.998 1.451 60.098 1.343 105.007-.008 3.148-2.422 3.815-2.368 6.849-.01 7.912 4.135 27.856 9.278 28.02 4.805-.237 11.742-7.604 12.103-18.159 2.706-49.996 7.297-115.745 11.256-124.15 4.988-10.59 13.59-7.742 14.45-17.856 1.272-14.154-19.131-22.602-41.552-25.734",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(5.154 -561.002)scale(.93642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.332 661.726c-11.04 0-32.463 30.34-32.524 36.72.118 8.198 20.742 15.7 20.326 27.908-.39 69.66-18.683 181.14-4.683 199.36 20.54 24.538 118.853 1.867 124.945-3.147 9.693-7.945 13.91-15.912 10.491-23.955-3.665-8.855-76.701 11.158-108.858-.7-13.498-4.957-3.985-100.612-3.751-156.8.684-12.785 25.766-27.268 25.879-32.873.4-10.883-18.37-45.203-31.825-46.513",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(5.154 -561.002)scale(.93642)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPei);
export default __webpack_public_path__ + "static/media/Pei.4716028a6283638ca8b9e036b5f2ad26.svg";
export { ForwardRef as ReactComponent };